export class StepGuideSelectModel {
  constructor (onboarding) {
    this.onboarding = onboarding;
  }

  id = "guide_select_model";
  title = "Select Your Version";

  template = `
  <div class="onboarding-step" data-for="guide_select_model">
    
    <div class="onboarding-select-model-list">
      <div class="onboarding-select-model-list-item">
        <div class="onboarding-select-model-list-item__title">
          Temp Stick v1
        </div>
        <div class="onboarding-select-model-list-item__image">
          <img src="${window.site.home}/../assets/images/setup/temp-stick-v1.png" width="333" height="868" />
        </div>
        <div class="onboarding-select-model-list-item__select">
          <button type="button" class="button button--medium" data-for="v1" data-action="guide_select_model_version">
            Select v1
          </button>
        </div>
      </div>
      <div class="onboarding-select-model-list-item">
        <div class="onboarding-select-model-list-item__title">
          Temp Stick v2
        </div>
        <div class="onboarding-select-model-list-item__image">
          <img src="${window.site.home}/../assets/images/setup/temp-stick-v2.png" width="333" height="868" />
        </div>
        <div class="onboarding-select-model-list-item__select">
          <button type="button" class="button button--medium" data-for="v2" data-action="guide_select_model_version">
            Select v2
          </button>
          <p class="onboarding-select-model-list-item__select__note">
            *Has on/off switch
          </p>
        </div>
      </div>
    </div>
    
  </div>
  `;

  onBack = () => {

  }

  onActivate = () => {
    this.onboarding.hideBackButton();
  }

  bindActions = () => {

    this.$selectBtn = $(this.onboarding.container).find('button[data-action="guide_select_model_version"]');
    this.$selectBtn.on('click', e => {
      const version = $(e.currentTarget).data('for');

      switch(version) {
        case('v1'):
          this.onboarding.goToStep("guide_v1_setup_mode");
          break;
        case('v2'):
          this.onboarding.goToStep("guide_v2_setup_mode");
          break;
      }
    });

  }

}
